import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { ISettingsPaymentSystemsResponse } from '../types';
import {
  ADMIN_PAYMENT_SYSTEMS_PERMISSIONS,
  SETTINGS_PAYMENT_SYSTEMS_LIST_QUERY_KEY,
  SETTINGS_PAYMENT_SYSTEMS_LIST_URL,
} from '../constants';

export default function useSettingsPaymentSystemsListQuery(): IContextQueryResult<ISettingsPaymentSystemsResponse> {
  const { fetchGet } = useRestClient();

  return useContextQuery<ISettingsPaymentSystemsResponse, Error>({
    queryKey: [SETTINGS_PAYMENT_SYSTEMS_LIST_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet(SETTINGS_PAYMENT_SYSTEMS_LIST_URL, {
      signal,
      permission: ADMIN_PAYMENT_SYSTEMS_PERMISSIONS.PAYMENTSYSTEMLISTS_SHOW,
    }),
  });
}
